<template>
    <div class="container">
        <div class="page-content mt-10">
            <div class="row">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        Card Type Roulette
                    </h1>
                </div>

                <div class="col-xxl-6 col-xl-6 col-xl-6 col-md-6 col-12 p-1 row p-0 mb-2">
                    <div class="col-7">
                        <img :src="lastCard ? getCardImage() : '/assets/dipocaco/card_back.png'" alt="mystery card" class="card-display" v-on:click="cardClick">
                    </div>

                    <div class="col-5 row p-0">
                        <div class="col-4 type-wrapper" v-for="type in types">
                            <button :class="'btn btn-secondary '+(typeToBet === type ? 'active-type' : '')+' w-100 p-1'" v-on:click="toggleSelection(type)">
                                <img :src="'/assets/dipocaco/type-icons/'+type+'_lg.png'" :alt="type" class="type-icon">
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-xxl-6 col-xl-6 col-xl-6 col-md-6 col-12 px-3">
                    <div class="card">
                        <div class="row">
                            <div class="col-4 text-end pt-2">
                                <a href="javascript:" class="w-100" v-on:click="adjustBet(false)">
                                    <i class="fa fa-minus-circle" style="font-size: 3em; color: red"></i>
                                </a>
                            </div>
                            <div class="col-4 text-center"><h2>{{ bet }}</h2><small class="muted">Bet</small></div>
                            <div class="col-4 text-left pt-2">
                                <a href="javascript:" class="w-100" v-on:click="adjustBet(true)">
                                    <i class="fa fa-plus-circle" style="font-size: 3em; color: green"></i>
                                </a>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-success w-100 mt-2" v-on:click="betOnRandomCard">
                        BET
                    </button>
                </div>
            </div>
        </div>

        <card-detail-view-canvas :card="lastCard" :gallery="true"></card-detail-view-canvas>
    </div>
</template>

<script>
import CardService from "../../CardService";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";

export default {
    name: "CardRoulette",
    components: {CardDetailViewCanvas},
    data() {
        return {
            win: 0,
            bet: 10,
            resultMessage: "",
            lastWin: 0,
            types: [
                'Colorless',
                'Darkness',
                'Dragon',
                'Fairy',
                'Fighting',
                'Fire',
                'Grass',
                'Lightning',
                'Metal',
                'Psychic',
                'Water',
            ],
            typeToBet: null,
            lastCard: null
        };
    },
    mounted() {
        this.$store.commit('updateUserData');
    },
    beforeUnmount() {
    },
    computed: {
    },
    methods: {
        toggleSelection(type) {
            this.lastCard = null;
            this.typeToBet = type;
        },
        betOnRandomCard() {
            if (this.bet > this.$store.state.user.credit) {
                iziToast.warning({title: "Not enough credit"});
                return;
            }
            if (!this.typeToBet) {
                iziToast.warning({title: "Choose a type to bet on"});
                return;
            }

            this.$store.commit('updateUserCredits');

            axios.post('/api/casino/roulette/play', {
                bet: this.bet,
                typeToBet: this.typeToBet,
            }).then((response) => {
                this.$store.commit('updateUserCredits', true)
                this.lastWin = response.data.win;
                this.lastCard = JSON.parse(response.data.card.json);

                if (response.data.win > 0) {
                    iziToast.success({
                        title: "You won " + response.data.win + " credits",
                        position: 'topCenter',
                        timeout: 2500
                    });
                } else {
                    // iziToast.info({title: "Better luck next time!", position: 'topCenter'});
                }
            })
        },
        adjustBet(up = true) {
            let amount = 10;

            if (this.bet >= 1000) {
                amount = up ? 1000 : this.bet === 1000 ? -100 : -1000;
            } else if (this.bet >= 100) {
                amount = up ? 100 : this.bet === 100 ? -10 : -100;
            } else {
                amount = up ? 10 : -10;
            }

            this.bet += amount;

            if (this.bet > 5000) {
                this.bet = 5000;
                iziToast.info({title: 'Max bet is 5000.'})
            }

            if (this.bet < 10) {
                this.bet = 10;
                iziToast.info({title: 'Min bet is 10.'})
            }
        },
        getCardImage() {
            return CardService.getCardImageUrl(this.lastCard)
        },
        cardClick() {
            if (!this.lastCard) {
                return false;
            }

            this.activeCard = this.lastCard;
            this.$forceUpdate();

            setTimeout(() => {
                $("#card-detail-view-canvas").offcanvas('toggle');
            }, 300)
        }
    }
};
</script>

<style scoped lang="scss">
.card-display {
    width: 100%;
    //max-height: 70vh;
    border-radius: 10px;
}

.type-wrapper {
    padding: 0.5em;

    .type-icon {
        width: 100%;
    }
}

.active-type {
    background-color: green !important;
}
</style>
